//TODO importazione React
import { CheckSquareOutlined } from '@ant-design/icons';
import { yup } from '@framework/validation/initYup.ts';
import { Datatype } from '../../../../expressions/datatype/Datatype.ts';
import { getSimpleWidgetReference } from '../../../../expressions/references/builder/getSimpleWidgetReference.ts';
import { CustomWarningsRule } from '../../../../rules/repository/custom-warnings/CustomWarnings.rule.ts';
import { RequiredRule } from '../../../../rules/repository/required/Required.rule.ts';
import { tran } from '../../../../translations/schema/TranslationSchema.ts';
import { type IWidgetType } from '../../../IWidgetType.ts';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget.ts';
import { createCommonFormSchema } from '../common/createCommonFormSchema.ts';
import { BooleanWidgetComponent } from './BooleanWidgetComponent.tsx';
import {
  BooleanConfigComponent,
  BooleanWidgetConfigSchema,
} from './BooleanWidgetConfigComponent.tsx';
import { type IBooleanWidget } from './IBooleanWidget.ts';

export const BooleanWidgetType: IWidgetType<IBooleanWidget> = {
  name: 'Checkbox',
  icon: <CheckSquareOutlined />,
  mainType: WidgetMainType.Input,
  category: WidgetCategory.Input,
  type: WidgetType.Boolean,
  hasValue: true,
  getReference: getSimpleWidgetReference(Datatype.Boolean),
  formComponent: BooleanWidgetComponent,
  createFormSchema: ({ widget }) =>
    createCommonFormSchema(yup.boolean(), widget),
  previewComponent: BooleanWidgetComponent,
  configValidator: BooleanWidgetConfigSchema,
  configComponent: BooleanConfigComponent,
  translationSchema: tran.widget({
    label: tran.rte(),
    helpText: tran.rte(),
    text: tran.rte(),
    rules: tran.rules(),
  }),
  rules: [RequiredRule, CustomWarningsRule],
};
